export var Gender;
(function (Gender) {
    Gender["M"] = "M";
    Gender["F"] = "F";
})(Gender || (Gender = {}));
export var InviteStatus;
(function (InviteStatus) {
    InviteStatus["pending"] = "pending";
    InviteStatus["activated"] = "activated";
    InviteStatus["expired"] = "expired";
})(InviteStatus || (InviteStatus = {}));
export var BeaconType;
(function (BeaconType) {
    BeaconType["tete_a_tete"] = "tete_a_tete";
    BeaconType["group"] = "group";
})(BeaconType || (BeaconType = {}));
export var CardStyle;
(function (CardStyle) {
    CardStyle["matte"] = "matte";
    CardStyle["glossy"] = "glossy";
    CardStyle["textured"] = "textured";
})(CardStyle || (CardStyle = {}));
export var BeaconCategory;
(function (BeaconCategory) {
    BeaconCategory["coffee"] = "coffee";
    BeaconCategory["walk"] = "walk";
    BeaconCategory["trips"] = "trips";
    BeaconCategory["games"] = "games";
    BeaconCategory["evening"] = "evening";
    BeaconCategory["active"] = "active";
    BeaconCategory["culture"] = "culture";
    BeaconCategory["cowork"] = "cowork";
    BeaconCategory["help"] = "help";
})(BeaconCategory || (BeaconCategory = {}));
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["pending"] = "pending";
    ResponseStatus["accepted"] = "accepted";
    ResponseStatus["rejected"] = "rejected";
    ResponseStatus["withdrawn"] = "withdrawn";
})(ResponseStatus || (ResponseStatus = {}));
export var PersonalInviteStatus;
(function (PersonalInviteStatus) {
    PersonalInviteStatus["pending"] = "pending";
    PersonalInviteStatus["accepted"] = "accepted";
    PersonalInviteStatus["silent"] = "silent";
})(PersonalInviteStatus || (PersonalInviteStatus = {}));
export var MeetingStatus;
(function (MeetingStatus) {
    MeetingStatus["active"] = "active";
    MeetingStatus["completed"] = "completed";
    MeetingStatus["expired"] = "expired";
})(MeetingStatus || (MeetingStatus = {}));
export var MeetingOrigin;
(function (MeetingOrigin) {
    MeetingOrigin["beacon"] = "beacon";
    MeetingOrigin["personal"] = "personal";
})(MeetingOrigin || (MeetingOrigin = {}));
export var MessageType;
(function (MessageType) {
    MessageType["text"] = "text";
    MessageType["photo"] = "photo";
    MessageType["audio"] = "audio";
})(MessageType || (MessageType = {}));
export var SwipeDecision;
(function (SwipeDecision) {
    SwipeDecision["skip"] = "skip";
    SwipeDecision["invite"] = "invite";
})(SwipeDecision || (SwipeDecision = {}));
